// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__vyjyd","wrapper_without_margin":"Wrapper_wrapper_without_margin__2vmsA"};